import {
  GET_TIMELINE_STATUS_REQUEST,
  GET_TIMELINE_STATUS_SUCCESS,
  GET_TIMELINE_STATUS_FAILURE,
  POST_TIMELINE_STATUS_REQUEST,
  POST_TIMELINE_STATUS_SUCCESS,
  POST_TIMELINE_STATUS_FAILURE,
  DELETE_TIMELINE_STATUS_BY_ID_REQUEST,
  DELETE_TIMELINE_STATUS_BY_ID_SUCCESS,
  DELETE_TIMELINE_STATUS_BY_ID_FAILURE,
  GET_RECORDING_DATA_REQUEST,
  GET_RECORDING_DATA_SUCCESS,
  GET_RECORDING_DATA_FAILURE,
  GET_TIMELINE_STATUS_BY_ID_REQUEST,
  GET_TIMELINE_STATUS_BY_ID_SUCCESS,
  GET_TIMELINE_STATUS_BY_ID_FAILURE,
} from '../../constants/ActionTypes'

import { TimelineApi } from '../api/TimelineApi';
import { TimelineStatusSortType } from '../../constants/ComponentTypes';

/*** GET /timeline_status ***/
const getTimelineStatusRequest = (id) => ({
  type: GET_TIMELINE_STATUS_REQUEST,
  payload: {
    id: id
  }
});

const getTimelineStatusSuccess = (id, statuses) => ({
  type: GET_TIMELINE_STATUS_SUCCESS,
  payload: {
    id: id,
    statuses: statuses
  }
});

const getTimelineStatusFailure = (id, error) => ({
  type: GET_TIMELINE_STATUS_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function getTimelineStatus(id, data = {}) {
  return async (dispatch) => {
    dispatch(getTimelineStatusRequest(id));

    TimelineApi.getTimelineStatus({
      "sort_type": TimelineStatusSortType.SORT_TYPE_CREATED_AT_ASC,
      ...data
    }, dispatch)
      .then((response) => {
        dispatch(getTimelineStatusSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getTimelineStatusFailure(id, error.response));
      });
  };
}

/*** POST /timeline_status ***/
const postTimelineStatusRequest = (id) => ({
  type: POST_TIMELINE_STATUS_REQUEST,
  payload: {
    id: id
  }
});

const postTimelineStatusSuccess = (id, status) => ({
  type: POST_TIMELINE_STATUS_SUCCESS,
  payload: {
    id: id,
    status: status
  }
});

const postTimelineStatusFailure = (id, error) => ({
  type: POST_TIMELINE_STATUS_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function postTimelineStatus(id, data) {
  return async (dispatch) => {
    dispatch(postTimelineStatusRequest(id));

    TimelineApi.postTimelineStatus(data, dispatch)
      .then((response) => {
        dispatch(postTimelineStatusSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(postTimelineStatusFailure(id, error.response));
      });
  };
}

/*** DELETE /timeline_status/{id} ***/
const deleteTimelineStatusByIdRequest = () => ({
  type: DELETE_TIMELINE_STATUS_BY_ID_REQUEST,
});

const deleteTimelineStatusByIdSuccess = (id) => ({
  type: DELETE_TIMELINE_STATUS_BY_ID_SUCCESS,
  payload: {
    id: id,
  }
});

const deleteTimelineStatusByIdFailure = (error) => ({
  type: DELETE_TIMELINE_STATUS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export function deleteTimelineStatusById(id) {
  return async (dispatch) => {
    dispatch(deleteTimelineStatusByIdRequest());

    TimelineApi.deleteTimelineStatusById(id, dispatch)
      .then(() => {
        dispatch(deleteTimelineStatusByIdSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteTimelineStatusByIdFailure(error.response));
      });
  };
}

/*** GET /timeline_status{id}/recording_data ***/
const getRecordingDataRequest = (id) => ({
  type: GET_RECORDING_DATA_REQUEST,
  payload: {
    id: id
  }
});

const getRecordingDataSuccess = (id, data) => ({
  type: GET_RECORDING_DATA_SUCCESS,
  payload: {
    id: id,
    data: data
  }
});

const getRecordingDataFailure = (id, error) => ({
  type: GET_RECORDING_DATA_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

export function getRecordingData(id) {
  return async (dispatch) => {
    dispatch(getRecordingDataRequest(id));

    TimelineApi.getRecordingData(id, dispatch)
      .then((response) => {
        dispatch(getRecordingDataSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getRecordingDataFailure(id, error.response));
      });
  };
}

const getTimelineStatusByIdSuccess = (id, timelineStatus) => ({
  type: GET_TIMELINE_STATUS_BY_ID_SUCCESS,
  payload: {
    id: id,
    timelineStatus: timelineStatus
  }
});

const getTimelineStatusByIdFailure = (id, error) => ({
  type: GET_TIMELINE_STATUS_BY_ID_FAILURE,
  payload: {
    id: id,
    error: error
  }
});

/*** GET /timeline_status/{id} ***/
const getTimelineStatusByIdRequest = (id) => ({
  type: GET_TIMELINE_STATUS_BY_ID_REQUEST,
  payload: {
    id: id
  }
});

export function getTimelineStatusById(id) {
  return async (dispatch) => {
    dispatch(getTimelineStatusByIdRequest(id));

    TimelineApi.getTimelineStatusById(id, dispatch)
      .then((response) => {
        dispatch(getTimelineStatusByIdSuccess(id, response.data.data));
      })
      .catch((error) => {
        dispatch(getTimelineStatusByIdFailure(id, error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/Timeline.js